import {
  FETCH_STOCK_TRANSFER_APPROVERS_REQUEST,
  FETCH_STOCK_TRANSFER_APPROVERS_SUCCESS,
  FETCH_STOCK_TRANSFER_APPROVERS_ERROR,

  SAVE_STOCK_TRANSFER_APPROVERS_REQUEST,
  SAVE_STOCK_TRANSFER_APPROVERS_SUCCESS,
  SAVE_STOCK_TRANSFER_APPROVERS_ERROR,

  FETCH_STOCK_TRANSFER_APPROVERS_MISSION_REQUEST,
  FETCH_STOCK_TRANSFER_APPROVERS_MISSION_SUCCESS,
  FETCH_STOCK_TRANSFER_APPROVERS_MISSION_ERROR,

  CLEAR_SUCCESS_MESSAGE
} from 'actionTypes'

const DEFAULT_STATE = {
  list: {
    records: [],
    error: null,
    isFetching: false,
    options: [],
  },
  missions: {
    records: [],
    error: null,
    isFetching: false,
  },
  get: {
    record: {},
    error: null,
    isFetching: false,
  },
  edit: {
    record: {},
    error: null,
    isUpdating: false,
    updated: false,
    removed: false,
  },
  change: {
    record: {},
    error: null,
    isUpdating: false,
    updated: false,
  },

  success: '',
}

const record = (state = DEFAULT_STATE, action) => {
  switch (action.type) {

    case FETCH_STOCK_TRANSFER_APPROVERS_REQUEST:
      return {
        ...state,
        missions: {
          ...state.missions,
          isFetching: true,
        },
      }

      case FETCH_STOCK_TRANSFER_APPROVERS_SUCCESS:
      return {
        ...state,
        missions: {
          ...state.missions,
          isFetching: false,
          error: null,
          records: action.payload,
        },
      }

    case FETCH_STOCK_TRANSFER_APPROVERS_ERROR:
      return {
        ...state,
        missions: {
          ...state.missions,
          isFetching: false,
          records: [],
          error: action.payload,
        },
      }
    
    case SAVE_STOCK_TRANSFER_APPROVERS_REQUEST:
      return {
        ...state,
        edit: {
          ...state.edit,
          isUpdating: true,
          
        },
      }

    case SAVE_STOCK_TRANSFER_APPROVERS_SUCCESS:
      return {
        ...state,
        success: 'stock-transfer-approvers.save.success',
      }

    case SAVE_STOCK_TRANSFER_APPROVERS_ERROR:
      return {
        ...state,
        success: '',
        change: {
          ...state.edit,
          isUpdating: false,
          error: action.payload,
          record: {},
          updated: false,
          removed: false,
        },
      }

    case FETCH_STOCK_TRANSFER_APPROVERS_MISSION_REQUEST:
      return {
        ...state,
      }

    case FETCH_STOCK_TRANSFER_APPROVERS_MISSION_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          options: action.payload,
        },
      }

    case FETCH_STOCK_TRANSFER_APPROVERS_MISSION_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          options: '',
        },
      }
    
    case CLEAR_SUCCESS_MESSAGE:
      return {
        ...state,
        success: '',
      }

    default:
      return state
  }
}

export default record
